// The ECONIC wordmark (DESIGN-SYSTEM §9): the logo of 17 Oct 2026 (public/brand/econic-logo-master.svg, cropped to its letters as
// econic-wordmark.svg, 788.8 × 158.9; the reverse has white letters). Never set in
// live type, never recoloured beyond its two supplied variants: navy (ribbon O gold over teal) on light, reverse on navy. Minimum 18 px
// high; the toolbar 18 px (a 16 px cap height, §00.2); landing start column 86 px; clear space = the height of the O on all sides (the caller's margin). WP-THEME.
import type { ImgHTMLAttributes } from "react";
import { useDocumentTheme } from "../theme/document";
import { BRAND, BRAND_RATIO, PRODUCT_NAME } from "./names";

export interface WordmarkProps extends Omit<ImgHTMLAttributes<HTMLImageElement>, "src" | "alt" | "width" | "height"> {
  /** Height in px (≥ 18). */
  height?: number;
  /** "auto" follows html[data-theme] (reverse in dark); "navy" and "reverse" force a variant (reverse on navy surfaces). */
  tone?: "auto" | "navy" | "reverse";
  /** When a visible label next to it already says ECONIC (or the parent link is labelled), the image is decorative. */
  decorative?: boolean;
}

export function Wordmark({ height = 18, tone = "auto", decorative = false, className, style, ...rest }: WordmarkProps) {
  const theme = useDocumentTheme();
  const reverse = tone === "reverse" || (tone === "auto" && theme === "dark");
  const h = Math.max(18, height);
  return (
    <img
      src={reverse ? BRAND.wordmarkReverse : BRAND.wordmark}
      alt={decorative ? "" : PRODUCT_NAME.en}
      width={Math.round(h * BRAND_RATIO.wordmark)}
      height={h}
      draggable={false}
      decoding="async"
      className={className}
      style={{ display: "block", height: h, width: "auto", flex: "none", ...style }}
      {...rest}
    />
  );
}
